const title = '可达鸭加盟校管理系统'
const getTitle = function(tit) {
    let allTitle = tit + '-' + title
    return allTitle
}
export default getTitle